/**
 * Csv Schema of TypeWebhook
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {TypeWebhook} from '@/model/resource/TypeWebhook'

/* TODO: review generated schema */
export class CsvTypeWebhookSchema extends Schema {
  readonly name = 'CsvTypeWebhook'

  readonly fieldSet: FieldSet<TypeWebhook> = {
    idTypePk: schema => schema.model.idTypePk,
    nome: schema => schema.model.nome,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
